import { render, staticRenderFns } from "./InternationalBankAccounts.vue?vue&type=template&id=66f47679&scoped=true&"
import script from "./InternationalBankAccounts.vue?vue&type=script&lang=js&"
export * from "./InternationalBankAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f47679",
  null
  
)

export default component.exports